import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { AddressAutocompleteSuggestion } from '@/types/addressValidation';

interface Props {
  readonly item: AddressAutocompleteSuggestion;
}

export const AddressSearchResultItem: React.FC<Props> = (props: Props): React.ReactElement => {
  const { item } = props;

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant="body2">{item.mainText}</Typography>
      <Typography variant="body1" color="text.secondary">
        {item.secondaryText}
      </Typography>
    </Box>
  );
};
